import { Dayjs } from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export default function RepresentmentStartDateField({
  value, onChange, disabled,
}: {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  disabled?: boolean;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Represented from"
        value={value}
        onChange={onChange}
        disabled={disabled}
        format="YYYY-MM-DD"
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            helperText: 'Disputes received before this date are not expected to be assigned to an agent.',
          },
        }}
      />
    </LocalizationProvider>
  );
}
